import * as React from 'react';
import cn from 'classnames';
import { SmsNotifications } from '../../../../../../CheckoutAdditionalService/components';
import { CdnIcon } from '@shared/ui';
import { useTheme } from '../../../../../../theme';

const SmsIcon = <CdnIcon key="sms" icon="Services/SMS" />;

interface Props {
	hideCard?: boolean;
}

const Sms: React.FC<Props> = ({ hideCard }) => {
	const theme = useTheme('Checkout').ServicesAggregationPage;

	return (
		<SmsNotifications
			className={cn({
				[theme.hideServiceCard]: hideCard
			})}
			aggregationIcons={[SmsIcon]}
			mode="aggregator"
		/>
	);
};

export default Sms;
